import styled from 'styled-components';
import { Card } from '@perch-labs/shrike';

export const CenteredCard = styled(Card)`
  text-align: center;
`;
